/**
 * Stammdaten-Store — Einheiten + Kategorien (einmal laden, im Speicher halten).
 * Liefert Lookup-Helfer fuer Anzeige (ID -> Name).
 */

import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { ladeEinheiten, ladeKategorien } from '@core/api/stammdaten.service';
import type { Einheit, Kategorie, Richtung } from '@core/api/types';

export const useStammdatenStore = defineStore('stammdaten', () => {
  const einheiten = ref<Einheit[]>([]);
  const kategorien = ref<Kategorie[]>([]);
  const geladen = ref(false);

  async function laden(erzwingen = false) {
    if (geladen.value && !erzwingen) return;
    const [e, k] = await Promise.all([ladeEinheiten(), ladeKategorien()]);
    einheiten.value = e;
    kategorien.value = k;
    geladen.value = true;
  }

  const kategorienNach = (richtung: Richtung) =>
    kategorien.value.filter((k) => k.richtung === richtung);

  const einheitName = (id: string) => einheiten.value.find((e) => e.id === id)?.name ?? id;
  const kategorieName = (id: string) => kategorien.value.find((k) => k.id === id)?.name ?? id;

  const einheitenSortiert = computed(() =>
    [...einheiten.value].sort((a, b) => a.sortierung - b.sortierung)
  );

  return {
    einheiten, kategorien, geladen, laden,
    kategorienNach, einheitName, kategorieName, einheitenSortiert,
  };
});
